// Words for the daily loop's pages (Part A, 3 Nov 2026): the leaderboards, the profile, Home's week strip. Sentence case,
// UK English, no exclamation marks; "MedSnapp", "we".
import type { ProfileView } from '@shared/types';
import { ordinal, streakLabel } from './format';

export const GROUP_WEEK = 'Your week';

export const BOARDS = {
  title: 'Leaderboards',
  tabs: { global: 'Global', university: 'University', friends: 'Friends' } as const,
  weeks: { this: 'This week', last: 'Last week' } as const,
  columns: { place: 'Place', name: 'Name', points: 'Points', battles: 'Battles' },
  you: 'You',
  empty: 'Nothing on the board yet this week.',
  noUniversity: 'The university board needs a verified university email.',
  resets: 'Resets Monday at 00:00, UK time.',
  failed: 'The board did not load.',
  verified: 'Verified',
  loading: 'Loading the board',
} as const;

export const PROFILE = {
  title: 'Profile',
  name: 'Display name',
  nameHint: 'Shown on the leaderboards. Up to 24 characters, one change a day.',
  chooseName: 'Choose a name',
  save: 'Save',
  saved: 'Saved.',
  figures: { streak: 'Streak', accuracy: 'Accuracy', battles: 'Battles', best: 'Best place' },
  week: 'This week',
  weekLine: (place: number | undefined, points: number) => (place ? `${ordinal(place)} · ${points} pts` : `${points} pts`),
  ranks: 'Last 12 weeks',
  noRanks: 'Your places appear here from next Monday.',
  verified: 'Verified',
  badgeLine: (b: ProfileView['badge']) => (b?.kind === 'nhs' ? 'NHS email' : `${b?.university} email`),
  timeZone: 'Time zone',
  failed: 'Your profile did not load.',
} as const;

export const FRIENDS = {
  title: 'Friends',
  none: 'No friends yet. Share your link.',
  link: 'Friend link',
  copy: 'Copy link',
  copied: 'Copied.',
  newLink: 'New link',
  newLinkHint: 'The old link stops working.',
  confirmNew: 'Make a new link',
  cancel: 'Keep it',
  requests: 'Requests',
  accept: 'Accept',
  ignore: 'Ignore',
  remove: 'Remove',
  add: (name: string) => `Add ${name} as a friend`,
  added: (name: string) => `You and ${name} are friends.`,
  requested: (name: string) => `Request sent to ${name}.`,
  own: 'That is your own link.',
  dead: 'This friend link no longer works.',
  signIn: 'Sign in to add a friend',
  boardEmpty: 'Add friends to see them here.',
  failed: 'That did not work. Try again.',
  loading: 'Loading',
  since: (at: number) => `Friends since ${new Date(at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}`,
} as const;

export const STRIP = {
  label: 'Your week so far',
  streak: (n: number) => `${streakLabel(n)} streak`,
  noStreak: 'No streak yet',
  week: (place: number | undefined, points: number) => (place ? `${ordinal(place)} this week · ${points} pts` : `${points} pts this week`),
  boards: 'Leaderboards',
  topic: (t: string) => `Topic of the week: ${t}`,
} as const;
